'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _about = require('./about.html');

var _about2 = _interopRequireDefault(_about);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstRun = true;

var ctor = {
    data: function data() {
        return {
            about_open: false
        };
    },
    computed: {
        networks: function networks() {
            return _state2.default.networks;
        },
        aboutContent: function aboutContent() {
            return _about2.default;
        }
    },
    methods: {
        addNetwork: function addNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});
            network.showServerBuffer('settings');
        },
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.show');
        },
        init: function init() {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _state2.default.persistence.watchStateForChanges();
                                _this.$emit('start', {
                                    fallbackComponent: _this.constructor
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (firstRun) {
                                this.init();
                                firstRun = false;
                            }

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }()
};

exports.default = ctor;

_state2.default.getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/thirdparty/kiwiirccom.vue
// module id = QrdV
// module chunks = 1